import * as React from "react";

import { cn } from "@/src/lib/utils";

interface HighlightProps extends React.HTMLAttributes<HTMLSpanElement> {}

export function Highlight({ className, children, ...props }: HighlightProps) {
  return (
    <span className={cn("text-brand", className)} {...props}>
      {children}
    </span>
  );
}
